import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "mdb-ui-kit/css/mdb.min.css";
import "mdb-ui-kit/js/mdb.min";
import "material-icons/iconfont/material-icons.css";
import { Provider } from "react-redux";
import store from "./Redux/reduxStore";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
